export default "__VITE_ASSET__C7FU$jBc__"